import { colors } from "assets/colors/colors";
import { Typography } from "components/Common/Typography/Typography";
import { BrandTableSelectableCell } from "./selectable_cell";
import "./list_item.scss";
import { BRAND_TABLE_ACTIONS_COLUMN_DATA_KEY } from "./virtualised_table";
import { useWatch } from "react-hook-form";
import cn from "classnames";

export const BrandTableListItem = ({
  rowData,
  columns,
  formControl,
  formFieldName,
  tableProperties,
  index,
}) => {
  const selectableColumn = columns.find((column) => column.selectable);
  const hasSelection = !!(
    selectableColumn &&
    formControl &&
    formFieldName
  );

  if (hasSelection) {
    return (
      <RowSelectionState
        formControl={formControl}
        formFieldName={formFieldName}
        selectableColumn={selectableColumn}
        rowData={rowData}
      >
        {(isSelected) =>
          renderListItem({
            rowData,
            columns,
            formControl,
            formFieldName,
            tableProperties,
            index,
            isSelected,
          })
        }
      </RowSelectionState>
    );
  }

  return renderListItem({
    rowData,
    columns,
    formControl,
    formFieldName,
    tableProperties,
    index,
    isSelected: false,
  });
};

const RowSelectionState = ({
  formControl,
  formFieldName,
  selectableColumn,
  rowData,
  children,
}) => {
  const selectedValue = useWatch({
    control: formControl,
    name: formFieldName,
  });
  const isMultiple = selectableColumn?.isMultiple ?? false;
  const isSelected = (isMultiple ? selectedValue || [] : [selectedValue]).some(
    (item) => [item?.uuid, item].includes(rowData.uuid),
  );

  return children(isSelected);
};

const renderListItem = ({
  rowData,
  columns,
  formControl,
  formFieldName,
  tableProperties,
  index,
  isSelected,
}) => {
  return (
    <div
      className={cn("brand-table-list-item", {
        "brand-table-list-item_selected": isSelected,
        "brand-table-list-item_first": index === 0,
      })}
    >
      {columns.map((column, index) => {
        if (column.dataKey === BRAND_TABLE_ACTIONS_COLUMN_DATA_KEY) {
          return (
            <div
              className="brand-table-list-item__column brand-table-list-item__column-actions"
              key={column.dataKey}
              onClick={(e) => e.stopPropagation()}
            >
              {column.children({
                rowData: rowData,
                tableProperties,
                isWideScreen: false,
                index: index,
              })}
            </div>
          );
        }

        const label = (
          <div className="brand-table-list-item__column__label">
            <Typography
              variant="title"
              color={colors.core70}
              text={column.label}
            />
            {column.description && (
              <Typography
                variant="h4"
                color={colors.core50}
                text={column.description}
              />
            )}
          </div>
        );

        if (column.selectable && formControl && formFieldName) {
          return (
            <div
              className="brand-table-list-item__column brand-table-list-item__column__selectable"
              key={column.dataKey || "selectable"}
            >
              <BrandTableSelectableCell
                rowData={rowData}
                formControl={formControl}
                formFieldName={formFieldName}
                column={column}
              />
            </div>
          );
        }

        return (
          <div key={index} className="brand-table-list-item__column">
            {label}
            <Typography
              className="brand-table-list-item__column__value"
              variant="title"
              text={
                column.children?.({
                  rowData,
                  tableProperties,
                  isWideScreen: false,
                  index: index,
                }) || rowData[column.dataKey]
              }
            />
          </div>
        );
      })}
    </div>
  );
};
